import _ from "lodash";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";
import CurrentSession from "data/userSession";
import Logger from "utils/logger";

class HapticService {
  /**
   * Check if haptics are enabled for the current user
   */
  get isEnabled(): boolean {
    if (!Capacitor.isNativePlatform()) return false;

    // Check if user has haptics disabled in preferences
    const user = CurrentSession.user;
    if (_.get(user, "preferences.haptic", false) === false) {
      return false;
    }

    return true;
  }

  /**
   * Quick short buzz for start/stop button
   */
  async quick(double = false): Promise<void> {
    if (!this.isEnabled) return;

    try {
      await Haptics.impact({ style: ImpactStyle.Light });
      if (double) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        await Haptics.impact({ style: ImpactStyle.Light });
      }
    } catch (error) {
      Logger.warn("Haptic feedback failed:", error);
    }
  }

  /**
   * Slightly longer buzz for successful save
   */
  async buzz(double = false): Promise<void> {
    if (!this.isEnabled) return;

    try {
      await Haptics.impact({ style: ImpactStyle.Heavy });
      if (double) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        await Haptics.impact({ style: ImpactStyle.Heavy });
      }
    } catch (error) {
      Logger.warn("Haptic feedback failed:", error);
    }
  }

  /**
   * Rapid 3 buzz pattern for confetti/celebration
   */
  async celebrate(): Promise<void> {
    if (!this.isEnabled) return;

    try {
      // Rapid 3 buzz pattern
      await Haptics.impact({ style: ImpactStyle.Heavy });
      await new Promise((resolve) => setTimeout(resolve, 100));
      await Haptics.impact({ style: ImpactStyle.Heavy });
      await new Promise((resolve) => setTimeout(resolve, 100));
      await Haptics.impact({ style: ImpactStyle.Heavy });
    } catch (error) {
      Logger.warn("Haptic feedback failed:", error);
    }
  }
}

export const haptics = new HapticService();
export default haptics;
